import { Route } from 'react-router-dom'
import { PageLayout } from 'containers'

import { Routes } from '../Routes'
import { GuestKaraokeRouter } from './Karaoke'
import { GuestTriviaRouter } from './Trivia'

export const GuestGameRouter = () => {
  return (
    <Routes>
      <Route path="trivia/*" element={<GuestTriviaRouter />} />
      <Route path="karaoke/*" element={<GuestKaraokeRouter />} />
    </Routes>
  )
}
